// Shared "Share this report" modal, used by both the full validator and the
// package-check page. Given a report URL + expiry it renders a copy-link
// dialog over the page.

export function openShareModal(url: string, expiresAt: string): void {
  const existing = document.querySelector(".share-modal-backdrop");
  if (existing) existing.remove();

  const backdrop = document.createElement("div");
  backdrop.className = "share-modal-backdrop";
  backdrop.addEventListener("click", (e) => {
    if (e.target === backdrop) backdrop.remove();
  });

  const modal = document.createElement("div");
  modal.className = "share-modal";
  modal.setAttribute("role", "dialog");
  modal.setAttribute("aria-modal", "true");

  const title = document.createElement("h3");
  title.textContent = "Share this report";

  const sub = document.createElement("p");
  sub.className = "share-modal-sub";
  sub.innerHTML = `Anyone with this link can view the report (no file downloads).<br>The link expires <b>${escapeHtml(
    formatExpiryGmt(new Date(expiresAt)),
  )}</b>.`;

  const row = document.createElement("div");
  row.className = "share-modal-row";

  const input = document.createElement("input");
  input.type = "text";
  input.readOnly = true;
  input.value = url;
  input.addEventListener("focus", () => input.select());

  const copyBtn = document.createElement("button");
  copyBtn.type = "button";
  copyBtn.className = "btn primary";
  copyBtn.textContent = "Copy link";
  copyBtn.addEventListener("click", async () => {
    try {
      await navigator.clipboard.writeText(url);
      copyBtn.textContent = "Copied ✓";
      setTimeout(() => (copyBtn.textContent = "Copy link"), 1400);
    } catch {
      input.select();
      document.execCommand?.("copy");
      copyBtn.textContent = "Copied ✓";
      setTimeout(() => (copyBtn.textContent = "Copy link"), 1400);
    }
  });

  row.append(input, copyBtn);

  const closeBtn = document.createElement("button");
  closeBtn.type = "button";
  closeBtn.className = "btn ghost";
  closeBtn.textContent = "Close";
  closeBtn.addEventListener("click", () => backdrop.remove());

  const actions = document.createElement("div");
  actions.className = "share-modal-actions";
  actions.append(closeBtn);

  modal.append(title, sub, row, actions);
  backdrop.append(modal);
  document.body.append(backdrop);
  input.focus();
}

function formatExpiryGmt(date: Date): string {
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, "0");
  const d = String(date.getUTCDate()).padStart(2, "0");
  const hh = String(date.getUTCHours()).padStart(2, "0");
  const mm = String(date.getUTCMinutes()).padStart(2, "0");
  return `${y}-${m}-${d} ${hh}:${mm} GMT`;
}

function escapeHtml(s: string): string {
  return s.replace(/[&<>"]/g, (c) =>
    c === "&" ? "&amp;" : c === "<" ? "&lt;" : c === ">" ? "&gt;" : "&quot;",
  );
}
